import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import {Checkbox, FormControlLabel, Grid, IconButton, Theme, Tooltip,} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import {
    CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
    CHANGE_DELIVERY_VEHICLE_LOG_START,
    CHANGE_FROMSTATION_VEHICLE_LOG_START,
    CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
    CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
    CHANGE_SHOWAFTER_VEHICLE_LOG_START,
    CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
    CHANGE_TOSTATION_VEHICLE_LOG_START,
    CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START
} from "@/Redux/Disposition/Constants";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import DeselectIcon from "@mui/icons-material/Deselect";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface GeneralFilterTabProps {
    predefinedFilter: any;
    setTmpFilter: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    tabBar: {
        backgroundColor: "white",
    },

    checkboxAllLabel: {
        fontWeight: 700,
    },

    formControl: {
        width: "100%",
    },
}));

const GeneralFilterTab: FunctionComponent<GeneralFilterTabProps> = ({
                                                                        predefinedFilter,
                                                                        setTmpFilter,
                                                                    }): JSX.Element => {
    const {classes} = useStyles();
    const {t} = useTranslation();

    const {
        delivery,
        pickupPlanned,
        pickupConfirmed,
        fromStation,
        toStation,
        withoutDelivered,
        allStations,
        showBefore,
        showAfter
    } = useAppSelector(state => state.disposition)

    const dispatch = useAppDispatch();
    const isVehicleLog = window.location.href.includes('manager/log');

    const changeShowBefore = () => {
        dispatch({
            type: CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
            payload: {
                showBefore: !showBefore
            }
        })
    }

    const changeShowAfter = () => {
        dispatch({
            type: CHANGE_SHOWAFTER_VEHICLE_LOG_START,
            payload: {
                showAfter: !showAfter
            }
        })
    }

    const changeDelivery = () => {
        dispatch({
            type: CHANGE_DELIVERY_VEHICLE_LOG_START,
            payload: {
                delivery: !delivery
            }
        })
    }

    const changePickupplanned = () => {
        dispatch({
            type: CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
            payload: {
                pickupPlanned: !pickupPlanned
            }
        })
    }

    const changePickupConfirmed = () => {
        dispatch({
            type: CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
            payload: {
                pickupConfirmed: !pickupConfirmed
            }
        })
    }

    const changeFromStation = () => {
        dispatch({
            type: CHANGE_FROMSTATION_VEHICLE_LOG_START,
            payload: {
                fromStation: !fromStation
            }
        })
    }

    const changeToStation = () => {
        dispatch({
            type: CHANGE_TOSTATION_VEHICLE_LOG_START,
            payload: {
                toStation: !toStation
            }
        })
    }

    const changeWithoutDelivered = () => {
        dispatch({
            type: CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START,
            payload: {
                withoutDelivered: !withoutDelivered
            }
        })
    }

    const changeAllStations = () => {
        dispatch({
            type: CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
            payload: {
                allStations: !allStations
            }
        })
    }

    const selectAll = () => {
        dispatch({
            type: CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
            payload: {
                showBefore: true
            }
        })

        dispatch({
            type: CHANGE_SHOWAFTER_VEHICLE_LOG_START,
            payload: {
                showAfter: true
            }
        })

        dispatch({
            type: CHANGE_DELIVERY_VEHICLE_LOG_START,
            payload: {
                delivery: true
            }
        })

        dispatch({
            type: CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
            payload: {
                pickupPlanned: true
            }
        })

        dispatch({
            type: CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
            payload: {
                pickupConfirmed: true
            }
        })

        dispatch({
            type: CHANGE_FROMSTATION_VEHICLE_LOG_START,
            payload: {
                fromStation: true
            }
        })

        dispatch({
            type: CHANGE_TOSTATION_VEHICLE_LOG_START,
            payload: {
                toStation: true
            }
        })

        dispatch({
            type: CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START,
            payload: {
                withoutDelivered: true
            }
        })

        dispatch({
            type: CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
            payload: {
                allStations: true
            }
        })
    }

    const deselectAll = () => {
        dispatch({
            type: CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
            payload: {
                showBefore: false
            }
        })

        dispatch({
            type: CHANGE_SHOWAFTER_VEHICLE_LOG_START,
            payload: {
                showAfter: false
            }
        })

        dispatch({
            type: CHANGE_DELIVERY_VEHICLE_LOG_START,
            payload: {
                delivery: false
            }
        })

        dispatch({
            type: CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
            payload: {
                pickupPlanned: false
            }
        })

        dispatch({
            type: CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
            payload: {
                pickupConfirmed: false
            }
        })

        dispatch({
            type: CHANGE_FROMSTATION_VEHICLE_LOG_START,
            payload: {
                fromStation: false
            }
        })

        dispatch({
            type: CHANGE_TOSTATION_VEHICLE_LOG_START,
            payload: {
                toStation: false
            }
        })

        dispatch({
            type: CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START,
            payload: {
                withoutDelivered: false
            }
        })

        dispatch({
            type: CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
            payload: {
                allStations: false
            }
        })
    }

    const handleCheckboxChange = (event: any) => {
        setTmpFilter(event.target.checked);
        /*if (event.target.checked) {
            setTmpFilter(true);
        }else{
            setTmpFilter(false);
        }*/
    };

    return (
        <>
            {!isVehicleLog && <Grid container spacing={1} style={{paddingBottom: 30}}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size={"small"}
                            name="checkedB"
                            color="secondary"
                            value={"test"}
                            onChange={handleCheckboxChange}
                            checked={predefinedFilter}
                        />
                    }
                    label={t(
                        "disposition.filter.messages.OnlyGroupReservationsOfStation"
                    )}
                />
            </Grid>}
            {isVehicleLog && <Grid container spacing={1}>
                <Grid item
                      xs={24}>
                    <Tooltip title={"Alle auswählen"}>
                        <IconButton
                            aria-label="Alle auswählen"
                            variant={"outlined"}
                            onClick={() => selectAll()}
                        >
                            <SelectAllIcon/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Alle abwählen"}>
                        <IconButton
                            aria-label="Alle abwählen"
                            variant={"outlined"}
                            style={{marginLeft: 5}}
                            onClick={() => deselectAll()}
                        >
                            <DeselectIcon/>
                        </IconButton>
                    </Tooltip>
                </Grid>

                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeDelivery}
                                checked={delivery}
                            />
                        }
                        label="Zustellungen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changePickupplanned}
                                checked={pickupPlanned}
                            />
                        }
                        label="Geplante Abholungen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeFromStation}
                                checked={fromStation}
                            />
                        }
                        label="Fahrzeuge, die von anderen Stationen benötigt werden"
                    />
                </Grid>
                <FormControlLabel
                    control={
                        <Checkbox
                            size={"small"}
                            name="delivered"
                            color="secondary"
                            value={"test"}
                            onChange={changeWithoutDelivered}
                            checked={withoutDelivered}
                        />
                    }
                    label="o. zugestellt"
                />
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changePickupConfirmed}
                                checked={pickupConfirmed}
                            />
                        }
                        label="Bestätigte Abholungen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeToStation}
                                checked={toStation}
                            />
                        }
                        label="Fahrzeuge, die andere Stationen benötigen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeAllStations}
                                checked={allStations}
                            />
                        }
                        label="Alle erlaubten Stationen anzeigen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeShowBefore}
                                checked={showBefore}
                            />
                        }
                        label="Vorgelagerte Vorgänge mit anzeigen"
                    />
                </Grid>
                <Grid item
                      xs={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="delivered"
                                color="secondary"
                                value={"test"}
                                onChange={changeShowAfter}
                                checked={showAfter}
                            />
                        }
                        label="Nachgelagerte Vorgänge mit anzeigen"
                    />
                </Grid>
            </Grid>}
        </>
    );
};

export default GeneralFilterTab;
